import Time16 from '@carbon/icons-react/es/time/16';
import React, { FC } from 'react';
import { ApprovalRequested } from 'api/notifications/meta';
import { ApprovalComment } from './approval-comment';

export const ApprovalRequestedComment: FC<{ meta: ApprovalRequested }> = ({
  meta: { message },
}) => {
  return message != null ? (
    <ApprovalComment
      content={message.content}
      icon={<Time16 />}
      background="var(--coolest-gray-10)"
    />
  ) : null;
};
